<template>
  <div
    class="flex justify-between m-4 bg-gray-200 rounded-lg overflow-hidden border border-gray-500"
  >
    <div class="p-4 pr-0">
      {{ flashMessage.message }}
    </div>
    <div class="flex items-center p-4 font-medium" @click="onClick">
      {{ flashMessage.cta.text }}
    </div>
  </div>
</template>

<script lang="ts">
import { mapMutations } from "vuex";

import { CLEAR_FLASH_MESSAGE } from "@/store/types/mutations";

export default {
  name: "FlashMessage",
  props: {
    index: Number,
    flashMessage: {
      required: true,
      type: Object,
    },
  },
  methods: {
    ...mapMutations([CLEAR_FLASH_MESSAGE]),
    onClick() {
      this.CLEAR_FLASH_MESSAGE(this.index);
      this.flashMessage.cta.action();
    },
  },
};
</script>
